//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showIntroBubble: true,
            showNext: false,
            puzzles: [
                {
                    image: 'w2d4_game_body.png',
                    inDropArea: false,
                    x: 819,
                    y: 150,
                    width: 180,
                    height: 242,
                    dropArea: {
                        xMin: 535,
                        xMax: 715,
                        yMin: 231,
                        yMax: 473
                    }
                },
                {
                    image: 'w2d4_game_foot.png',
                    inDropArea: false,
                    x: 238,
                    y: 331,
                    width: 164,
                    height: 126,
                    dropArea: {
                        xMin: 542,
                        xMax: 706,
                        yMin: 472,
                        yMax: 598
                    }
                },
                {
                    image: 'w2d4_game_head.png',
                    inDropArea: false,
                    x: 136,
                    y: 675,
                    width: 148,
                    height: 118,
                    dropArea: {
                        xMin: 550,
                        xMax: 698,
                        yMin: 115,
                        yMax: 233
                    }
                },
                {
                    image: 'w2d4_game_left_hand.png',
                    inDropArea: false,
                    x: 289,
                    y: 544,
                    width: 137,
                    height: 159,
                    dropArea: {
                        xMin: 414,
                        xMax: 551,
                        yMin: 143,
                        yMax: 302
                    }
                },
                {
                    image: 'w2d4_game_right_hand.png',
                    inDropArea: false,
                    x: 59,
                    y: 326,
                    width: 82,
                    height: 282,
                    dropArea: {
                        xMin: 688,
                        xMax: 770,
                        yMin: 273,
                        yMax: 555
                    }
                },
                {
                    image: 'w2d4_game_wheels.png',
                    inDropArea: false,
                    x: 53,
                    y: 170,
                    width: 307,
                    height: 96,
                    dropArea: {
                        xMin: 471,
                        xMax: 778,
                        yMin: 589,
                        yMax: 685
                    }
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.puzzles.filter(puzzle => puzzle.inDropArea).length;

            return this.$game.getDragDropResult(numCorrect, this.puzzles.length - numCorrect);
        }
    },

    methods: {
        dragend (puzzle, { x, y }) {
            this.showIntroBubble = false;

            puzzle.x = x;
            puzzle.y = y;
            puzzle.inDropArea = puzzle.x >= puzzle.dropArea.xMin - puzzle.width / 2 &&
                puzzle.x <= puzzle.dropArea.xMax - puzzle.width / 2 &&
                puzzle.y >= puzzle.dropArea.yMin - puzzle.height / 2 &&
                puzzle.y <= puzzle.dropArea.yMax - puzzle.height / 2;

            if (puzzle.inDropArea) {
                this.$nextTick(() => {
                    puzzle.x = puzzle.dropArea.xMin;
                    puzzle.y = puzzle.dropArea.yMin;
                });
            }
        }
    }
};
